import React from 'react'
import Catch from './functional-error-boundary'

import linkShapeSvg from '@assets/img/svg/ink-shape.svg'

type Props = {
  children: React.ReactNode
  fallback?: string
}
const ErrorBoundary = Catch((props: Props, error?: Error) => {
  if (error) {
    return (
      <div className="box">
        <figure className="mb-5 display-flex align-items-center justify-content-center" style={{ overflow: 'hidden' }}>
          <object style={{ maxWidth: '310px' }} aria-labelledby="Maintence Image" data={linkShapeSvg} type="image/svg+xml" />
        </figure>
        <p style={{ maxWidth: '500px', margin: '0 auto 1rem' }}>{props?.fallback}</p>
      </div>
    )
  } else {
    return <div>{props?.children}</div>
  }
})

export default ErrorBoundary
